
import jsPDF from 'jspdf';
import { EnviarCorreopdf } from '../../Componentes/FunctionLogin'
import cabeceraImage from './../../recursos/cabecera.png';


export async function generatePDF(tableData, valorCalificacion, firma, codigoInternoProveedor, nombreProveedor, tipoDocumento, numeroDocumento, direccion, prestadorBienesServicios,
    evaluador, cargo, categoria, fechaEvaluacion, periodoEvaluado, correoProveedor, responsableVisita, observacion, firmaFile2, responsableRecibir, sendEmail = false) {
    return new Promise((resolve) => {
        const doc = new jsPDF({
            orientation: 'landscape', // Configura la orientación del PDF como horizontal
        });

        doc.addImage(cabeceraImage, 'JPEG', 5, 5, 287, 50); // Ajusta las coordenadas y dimensiones

        // Agrega el contenido línea por línea

        doc.setFontSize(10)
        doc.cell(5, 55, 200, 13, 'EVALUACIÓN DE CALIDAD PROVEEDORES', 0);
        doc.cell(5, 55, 87, 13, 'Código: F-CS-CP-05 \nVersión: 07', 0);

        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(5, 70, 287, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('IDENTIFICACIÓN DEL PROVEEDOR', 150, 75, 'center');

        doc.setFont('', '');
        //------------------------------------------------------------------------------------------------


        var tablaCampos = [{ nombre: "CÓDIGO INTERNO DEL PROVEEDOR", value: codigoInternoProveedor, nombre1: "NOMBRE DEL PROVEEDOR", value1: nombreProveedor },
        { nombre: "TIPO DE DOCUMENTO", value: tipoDocumento, nombre1: "NÚMERO DE DOCUMENTO", value1: numeroDocumento },
        { nombre: "DIRECCIÓN", value: direccion, nombre1: "PRESTADOR DE BIENES O SERVICIOS", value1: prestadorBienesServicios },
        { nombre: "EVALUADOR", value: evaluador, nombre1: "CARGO", value1: cargo },
        { nombre: "CATEGORÍA A LA QUE PERTENECE", value: categoria, nombre1: "FECHA DE EVALUACIÓN", value1: fechaEvaluacion },
        { nombre: "PERÍODO EVALUADO", value: periodoEvaluado, nombre1: "CORREO ELECTRÓNICO DEL PROVEEDOR", value1: correoProveedor }];

        var yContactoRetangulo = 84, yTexto = 87;
        tablaCampos.forEach(element => {


            var nombrev2 = doc.splitTextToSize(element.nombre, 50);
            doc.setFont('', '');
            doc.setFontSize(10);
            doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(5, yContactoRetangulo, 80, 12, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
            doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
            doc.text(nombrev2, 6, yTexto, 'left');
            //-----

            doc.setFontSize(10);
            var valuev2 = doc.splitTextToSize(element.value, 50);
            doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(80, yContactoRetangulo, 80, 12, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
            doc.setTextColor(5, 0, 0); // Establece el color del texto en negro
            doc.text(valuev2, 81, yTexto, 'left');
            //-----

            doc.setFontSize(10);
            var nombre1v2 = doc.splitTextToSize(element.nombre1, 50);
            doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(160, yContactoRetangulo, 80, 12, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
            doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
            doc.text(nombre1v2, 161, yTexto, 'left');
            //-----

            doc.setFontSize(10);
            var value1v2 = doc.splitTextToSize(element.value1, 50);
            doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(240, yContactoRetangulo, 52, 12, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
            doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
            doc.text(value1v2, 241, yTexto, 'left');
            yContactoRetangulo = yContactoRetangulo + 12;
            yTexto = yTexto + 12;
        });

        //------------------------------------------------------------------------------------------------

        yContactoRetangulo = yContactoRetangulo + 10;
        yTexto = yTexto + 14;

        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245);
        doc.rect(35, (yContactoRetangulo + 1), 90, 14, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('SISTEMA DE PUNTUACIÓN', (35 + 1), (yTexto), 'left');

        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(90, (yContactoRetangulo + 1), 40, 7, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('1', (90 + 18), (yTexto - 3), 'left');
        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(90, (yContactoRetangulo + 1 + 7), 40, 7, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('2', (90 + 18), (yTexto + 3), 'left');

        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(130, (yContactoRetangulo + 1), 40, 7, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('No cumple', (130 + 7), (yTexto - 3), 'left');
        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(130, (yContactoRetangulo + 1 + 7), 40, 7, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('Cumple parcialmente', (130 + 7), (yTexto + 5), 'left');

        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(170, (yContactoRetangulo + 1), 40, 14, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('3', (170 + 18), (yTexto), 'justify');

        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(210, (yContactoRetangulo + 1), 40, 14, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('Cumple', (210 + 15), (yTexto), 'justify');


        doc.addPage()
        yContactoRetangulo = 10;
        yTexto = 15;


        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(5, yContactoRetangulo, 256.7, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('PARÁMETROS DE CALIFICACIÓN', 6, yTexto, 'left');
        //---------
        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(256.7, yContactoRetangulo, 36, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('CALIFICACIÓN', 257.7, yTexto, 'left');
        //--------

        const pageHeight = doc.internal.pageSize.getHeight(); // Obtén el ancho de la página



        var textoTablaPreguntas = yTexto;
        var RetanguloPreguntas = yContactoRetangulo;
        tableData.forEach(elementv1 => {
            textoTablaPreguntas = textoTablaPreguntas + 9;
            RetanguloPreguntas = RetanguloPreguntas + 9;
            doc.setFont('', 'bold');
            doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(5, RetanguloPreguntas, 287.7, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
            doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
            doc.text(elementv1.category, 6, textoTablaPreguntas - 1, 'left');

            textoTablaPreguntas = textoTablaPreguntas + 9;
            RetanguloPreguntas = RetanguloPreguntas + 9;

            elementv1.questions.forEach(element => {
                var evaluation = doc.splitTextToSize(element.evaluation, 200);
                var textLines = doc.splitTextToSize(element.question, 200);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 256.7, (textLines.length == 1 ? 17 : (textLines.length / 3) * 15), 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(textLines, 5, textoTablaPreguntas, 'left');


                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(257.7, RetanguloPreguntas, 35, (textLines.length == 1 ? 17 : (textLines.length / 3) * 15), 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${evaluation}`, 273, textoTablaPreguntas + 2, 'center');


                RetanguloPreguntas = RetanguloPreguntas + (textLines.length == 1 ? 15 : (textLines.length / 3) * 17);
                textoTablaPreguntas = textoTablaPreguntas + (textLines.length == 1 ? 15 : (textLines.length / 3) * 17);

                doc.setFontSize(10)
                if (RetanguloPreguntas >= 170) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

            })
        });

        yContactoRetangulo = RetanguloPreguntas;
        yTexto = textoTablaPreguntas + 5;
        yContactoRetangulo = yContactoRetangulo + 5;
        yTexto = yTexto + 2;

        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(5, yContactoRetangulo, 286.7, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('COMENTARIO', 150, yTexto, 'center');

        yContactoRetangulo = yContactoRetangulo + 9;
        yTexto = yTexto + 9;

        var observaciontext = doc.splitTextToSize(observacion, 290);
        doc.setFont('', '');
        doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(5, yContactoRetangulo, 286.7, (observaciontext.length == 1 ? 15 : (observaciontext.length / 3) * 16), 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text(observaciontext, 6, yTexto, 'left');

        yContactoRetangulo = yContactoRetangulo + (observaciontext.length == 1 ? 15 : (observaciontext.length / 3) * 16);
        yTexto = yTexto + (observaciontext.length == 1 ? 15 : (observaciontext.length / 3) * 16);
        textoTablaPreguntas = yTexto;
        RetanguloPreguntas = yContactoRetangulo;

        doc.setFontSize(10)
        if (RetanguloPreguntas >= 180) {
            doc.addPage()
            textoTablaPreguntas = 5;
            RetanguloPreguntas = 0;
        }

        var tablafinal = [1, 2, 3, 4, 5];
        tablafinal.forEach(element => {
            if (element == 1) {
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                textoTablaPreguntas = textoTablaPreguntas + 5;
                RetanguloPreguntas = RetanguloPreguntas + 5;
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(60, RetanguloPreguntas, 150, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Evaluación del Asociado de Negocio', 61, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(210, RetanguloPreguntas, 70, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${valorCalificacion} %`, 212, textoTablaPreguntas, 'left');
            } else if (element == 2) {

                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                textoTablaPreguntas = textoTablaPreguntas + 10;
                RetanguloPreguntas = RetanguloPreguntas + 10;
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(60, RetanguloPreguntas, 150, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('CALIFICACIÓN', 61, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                (valorCalificacion > 80 ? doc.setFillColor(51, 162, 23) : valorCalificacion > 60 && valorCalificacion <= 80 ? doc.setFillColor(255, 255, 0) : doc.setFillColor(255, 0, 0))
                // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(210, RetanguloPreguntas, 70, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${(valorCalificacion > 80 ? "FAVORABLE" : valorCalificacion > 60 && valorCalificacion <= 80 ? "FAVORABLE CONDICIONAL" : "NO FAVORABLE")} `, 212, textoTablaPreguntas, 'left');
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

            } else if (element == 3) {
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 20;
                RetanguloPreguntas = RetanguloPreguntas + 20;
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 75, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('TIPO DE ASOCIACION DE NEGOCIO', 6, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 40, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('PUNTAJE', 76, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(115, RetanguloPreguntas, 105, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('ACCIÓN A SEGUIR', 116, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(220, RetanguloPreguntas, 72, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('CONTROL', 221, textoTablaPreguntas, 'left');

                //--------------------------------------------------------------------------------------------------
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 9;
                RetanguloPreguntas = RetanguloPreguntas + 9;
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 75, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('FAVORABLE', 6, textoTablaPreguntas, 'left');

                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 40, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('> 80 ', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');

                var texto1 = doc.splitTextToSize("Enfatizar los puntos fuertes para que sostenga la posición y los no tan fuertes para que los mejore.", 70);
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(115, RetanguloPreguntas, 105, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto1, 116, textoTablaPreguntas, 'left');

                var texto2 = doc.splitTextToSize("No requiere verificación", 70);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(220, RetanguloPreguntas, 72, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('No requiere verificación', 221, textoTablaPreguntas, 'left');

                //--------------------------------------------------------------------------------------------------
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 14;
                RetanguloPreguntas = RetanguloPreguntas + 14;
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 75, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('FAVORABLE CONDICIONAL', 6, textoTablaPreguntas, 'left');

                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 40, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('> 60  Y <=80', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');

                var texto1 = doc.splitTextToSize("Presentar los puntos débiles para que implemente acciones.", 70);
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(115, RetanguloPreguntas, 105, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto1, 116, textoTablaPreguntas, 'left');

                var texto2 = doc.splitTextToSize("Verificación eventual a los tres Meses", 70);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(220, RetanguloPreguntas, 72, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto2, 221, textoTablaPreguntas, 'left');

                //--------------------------------------------------------------------------------------------------
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 14;
                RetanguloPreguntas = RetanguloPreguntas + 14;
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 75, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('NO FAVORABLE', 6, textoTablaPreguntas, 'left');

                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 40, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('> 0  Y <=60', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');

                var texto1 = doc.splitTextToSize("Se le informa al asociado que no ha cumplido con los parámetros esperados para continuar contando con sus servicios NO FAVORABLE.", 70);
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(115, RetanguloPreguntas, 105, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto1, 116, textoTablaPreguntas, 'left');

                var texto2 = doc.splitTextToSize("Estudiar los planes de acción enviados por el proveedor.", 70);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(220, RetanguloPreguntas, 72, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto2, 221, textoTablaPreguntas, 'left');

            } else if (element == 4) {

                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                /* doc.setFont('', 'bold');
                 doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                 doc.rect(0, 91, 300, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                 doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                 doc.text(`PRODUCTO O SERVICIOS QUE SUMINISTRA A LA EMPRESA: ${select}`, 1, 98, 'left');*/


                textoTablaPreguntas = textoTablaPreguntas + 25;
                RetanguloPreguntas = RetanguloPreguntas + 25;

                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                var politicas = doc.splitTextToSize("La sociedad CI TECNOLOGÍA ALIMENTARIA S.A.S “CI TALSA” es una sociedad comercial legalmente constituida con domicilio principal en la Carrera 50 GG Nº 12 Sur 83 del municipio de Itagüí, departamento de Antioquia, república de Colombia y para dar cumplimiento a lo establecido en la Ley 1581 de 2012, reglamentada por el Decreto Nº 1377 de 2013, relativos a la protección de datos personales, expide el siguiente reglamento para su adecuado tratamiento, en cumplimiento de las normas legales y de la filosofía de nuestra sociedad. Para ampliar la información ingrese al siguiente link:  https://www.citalsa.com/pages/politica-para-el-tratamiento-de-datos-personales ", 290);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 300, (80), 'F'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(politicas, 6, textoTablaPreguntas, 'left');

                if (RetanguloPreguntas >= 140) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }


                textoTablaPreguntas = textoTablaPreguntas + 20;
                RetanguloPreguntas = RetanguloPreguntas + 20;
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 150, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('RESPONSABLE DE LA EVALUACIÓN', 6, textoTablaPreguntas, 'left');

                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(150, RetanguloPreguntas, 142, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('RESPONSABLE DE LA EVALUACIÓN', 151, textoTablaPreguntas, 'left');




                //-----

                //-----------------------------------------------------
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                textoTablaPreguntas = textoTablaPreguntas + 9;
                RetanguloPreguntas = RetanguloPreguntas + 9;
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 150, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${responsableVisita}`, 6, textoTablaPreguntas, 'left');

                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(150, RetanguloPreguntas, 142, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${responsableRecibir}`, 151, textoTablaPreguntas, 'left');
                //-----



                textoTablaPreguntas = textoTablaPreguntas + 9;
                RetanguloPreguntas = RetanguloPreguntas + 9;
                doc.addImage(firma, 'JPEG', 0, RetanguloPreguntas, 150, 45);
                doc.setLineWidth(0.3); // Establece el grosor del borde en 1 (puedes ajustarlo según sea necesario)
                doc.setDrawColor(0); // Establece el color del borde en negro (RGB: 0, 0, 0)
                doc.rect(5, RetanguloPreguntas, 145, 45); // Dibuja un rectángulo alrededor de la primera imagen

                doc.addImage(firmaFile2, 'JPEG', 150, RetanguloPreguntas, 142, 45);
                doc.setLineWidth(0.3); // Establece el grosor del borde en 1 (puedes ajustarlo según sea necesario)
                doc.setDrawColor(0); // Establece el color del borde en negro (RGB: 0, 0, 0)
                doc.rect(150, RetanguloPreguntas, 142, 45); // Dibuja un rectángulo alrededor de la primera imagen

                //-----
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
            } else if (element == 5) {
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 55;
                RetanguloPreguntas = RetanguloPreguntas + 55;

                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(50, RetanguloPreguntas, 25, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Cargo', 51, textoTablaPreguntas + 4.5, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Elaborado POR:', 76, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(125, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Revisado por:', 126, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(175, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Aprobado por:', 176, textoTablaPreguntas, 'left');
                textoTablaPreguntas = textoTablaPreguntas + 8;
                RetanguloPreguntas = RetanguloPreguntas + 8;
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Líder de negociación en compras', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(125, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Analista de SGI', 126, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(175, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Director de Cadena de suministro', 176, textoTablaPreguntas, 'left');


                textoTablaPreguntas = textoTablaPreguntas + 8;
                RetanguloPreguntas = RetanguloPreguntas + 8;
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(50, RetanguloPreguntas, 25, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Fecha', 51, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('01-06-2023', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(125, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('01-06-2023', 126, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(175, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('05-06-2023', 176, textoTablaPreguntas, 'left');
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 5;
                    RetanguloPreguntas = 0;
                }
            }
            doc.setFontSize(10)
            if (RetanguloPreguntas >= 180) {
                doc.addPage()
                textoTablaPreguntas = 5;
                RetanguloPreguntas = 0;
            }
        })



        /*doc.setFillColor(255, 0, 0);
        doc.rect(45, 200, 200, 210, 'FD'); // Dibuja un rectángulo con el color de fondo
    */
        const pdfData = doc.output('arraybuffer');

        // Crea un objeto Blob a partir de los datos del PDF
        const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // Crea un objeto FileReader
        const reader = new FileReader();
        // Lee el contenido del Blob como una URL de datos
        reader.readAsDataURL(pdfBlob);
        // Escucha el evento "load" cuando la lectura se haya completado
        reader.onload = function () {
            // Obtiene la cadena base64 del resultado de la lectura
            const base64String = reader.result.split(',')[1];
            // Usa la cadena base64 como sea necesario (por ejemplo, enviarla al servidor, mostrarla en un elemento HTML, etc.)

            /*window.open(pdfUrl, '_blank');*/
            if (sendEmail) {
                EnviarCorreopdf(base64String, "juliana.ballon@talsa.com.co" + "," + localStorage.Email, nombreProveedor, "CALIFICACIÓN DE PROVEEDORES").then((result2) => {
                })
            }
            resolve(base64String)
        };
        /*window.open(pdfUrl, '_blank');*/
    })

}

